/**
 * Vídeos de avaliação da PDP (estilo Renova Be):
 * - a fileira pequena toca em loop, sem som, o tempo todo (prévia ambiente);
 * - clicar em qualquer miniatura abre um card com avatares no topo para trocar de vídeo,
 *   setas para o anterior/próximo, e o produto com preço e botão de compra embaixo do vídeo ativo.
 */
(() => {
  const boot1 = (scope = document) =>
    scope.querySelectorAll('[data-video-modal]').forEach((modal) => {
    if (modal.dataset.initialized) return;
    modal.dataset.initialized = 'true';

    const grid =
      (modal.previousElementSibling && modal.previousElementSibling.classList.contains('product-videos') && modal.previousElementSibling) ||
      (modal.parentElement && modal.parentElement.querySelector('.product-videos'));
    if (!grid) return;

    const openButtons = Array.from(grid.querySelectorAll('[data-video-open]'));
    const previewVideos = Array.from(grid.querySelectorAll('.product-videos__preview'));
    const slides = Array.from(modal.querySelectorAll('[data-video-slide]'));
    const avatars = Array.from(modal.querySelectorAll('[data-video-avatar]'));
    const closeButtons = Array.from(modal.querySelectorAll('[data-video-modal-close]'));
    const prevBtn = modal.querySelector('[data-video-prev]');
    const nextBtn = modal.querySelector('[data-video-next]');

    if (!slides.length) return;

    let activeIndex = 0;
    let lastFocused = null;

    // Prévia ambiente: toca todas as miniaturas em loop e sem som, o tempo todo.
    previewVideos.forEach((video) => {
      video.muted = true;
      const tryPlay = () => video.play().catch(() => {});
      if (video.readyState >= 2) {
        tryPlay();
      } else {
        video.addEventListener('loadeddata', tryPlay, { once: true });
      }
    });

    const pauseAll = () => {
      slides.forEach((slide) => {
        const video = slide.querySelector('video');
        if (video) video.pause();
      });
    };

    const showSlide = (index) => {
      if (!slides[index]) return;
      pauseAll();
      slides.forEach((slide, i) => {
        slide.hidden = i !== index;
      });
      avatars.forEach((avatar, i) => {
        avatar.setAttribute('aria-current', String(i === index));
      });
      activeIndex = index;

      const video = slides[index].querySelector('video');
      if (video) {
        video.currentTime = 0;
        video.muted = false;
        video.play().catch(() => {
          // Se o navegador recusar o som, toca mudo em vez de falhar silenciosamente.
          video.muted = true;
          video.play().catch(() => {});
        });
      }
    };

    const openModal = (index) => {
      lastFocused = document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      showSlide(index);
      const closeBtn = modal.querySelector('.video-reviews-modal__close');
      if (closeBtn) closeBtn.focus();
    };

    const closeModal = () => {
      modal.hidden = true;
      document.body.style.overflow = '';
      pauseAll();
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    };

    openButtons.forEach((button, i) => {
      button.addEventListener('click', () => openModal(i));
    });

    closeButtons.forEach((button) => button.addEventListener('click', closeModal));

    avatars.forEach((avatar, i) => {
      avatar.addEventListener('click', () => showSlide(i));
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', () => showSlide((activeIndex - 1 + slides.length) % slides.length));
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => showSlide((activeIndex + 1) % slides.length));
    }

    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeModal();
      if (event.key === 'ArrowLeft') showSlide((activeIndex - 1 + slides.length) % slides.length);
      if (event.key === 'ArrowRight') showSlide((activeIndex + 1) % slides.length);
    });
  });
  boot1();
  document.addEventListener('shopify:section:load', (event) => boot1(event.target));
})();
